module.exports = __webpack_public_path__ + "static/media/auction-terminate-t5.031df78d.nom";